import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Local } from '../classes/Local';

@Injectable({
  providedIn: 'root'
})
export class LocalService {

  constructor(private http: HttpClient) { }

  route = "Local";

  Listar(): Observable<any>{
    return this.http.get(`${environment.apiURL}/${this.route}`)
  }

  ObterPorId(id: string): Observable<any>{
    return this.http.get(`${environment.apiURL}/${this.route}/${id}`)
  }

  Inserir(obj: Local): Observable<any>{
    return this.http.post(`${environment.apiURL}/${this.route}`, obj);
  }

  Atualizar(id: string, obj: Local): Observable<any>{
    return this.http.put(`${environment.apiURL}/${this.route}/${id}`, obj);
  }

  Excluir(id: string): Observable<any>{
    return this.http.delete(`${environment.apiURL}/${this.route}/${id}`);
  }

}
